import { render } from "./PrintTes.vue?vue&type=template&id=90036820"
import script from "./PrintTes.vue?vue&type=script&lang=js"
export * from "./PrintTes.vue?vue&type=script&lang=js"

import "./PrintTes.vue?vue&type=style&index=0&id=90036820&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__